<template>
    <div>
        <card-header title="Portal User Activity" icon="fa-chart-line"/>

        <card-toolbar class="pt-2">
            <b-switch size="is-small" class="mr-4 ml-2" v-model="traffic">API Traffic</b-switch>
        </card-toolbar>

        <div class="custom-toolbar">
            <div class="columns">
                <div class="column">
                    <b-field label="Start Date" label-position="inside">
                        <b-datepicker append-to-body v-model="startDate" :min-date="minDate" :max-date="maxDate" @input="changeDate"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="End Date" label-position="inside">
                        <b-datepicker append-to-body v-model="endDate" :min-date="minDate" :max-date="maxDate" @input="changeDate"/>
                    </b-field>
                </div>
            </div>
        </div>

        <card-body>
            <card-list>

                <template v-for="act in activity">
                    <activity-traffic :activity="act" v-if="traffic && act.type === 'traffic'"/>
                </template>

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from "@/http_client";
    import ActivityTraffic from "../activity/ActivityTraffic";

    import moment from "moment";

    export default {
        components: {ActivityTraffic, CardToolbar, CardHeader, CardBody, CardList},
        props: ['card', 'props', 'child'],
        data() {
            return {
                activity: [],
                traffic: true,
                startDate: moment().set('date', 1).toDate(),
                endDate: new Date(),
                minDate: new Date(new Date().setYear(new Date().getFullYear() - 3)),
                maxDate: new Date(),
            };
        },
        methods: {
            load: function(force) {
                http.get('/portal-users/' + this.props.portalUserId + '/traffic/' + moment(this.startDate).format('YYYY-MM-DD') + '/' + moment(this.endDate).format('YYYY-MM-DD')).then((response) => {
                    this.activity = response.data;
                    this.$emit('loading', false);
                }).catch((error) => {
                    console.error(error);
                });
            },
            reload: function() {
                this.load(true);
            },
            changeDate: function() {
                this.load(true);
            },
        },
        mounted: function() {
            this.load();
        },
    };

</script>

<style lang="scss" scoped>
    .custom-toolbar {
        background: #f3f3f3;
        border-bottom: 1px solid #dee2e6;

        padding: 10px 0.4rem 10px 0.6rem;
    }
</style>
